import UserObj from 'models/user-obj'
import React from 'react'
import Avatar from './Avatar'
import UserInfo from './UserInfo'

interface AvatarUserInfoProps {
	user: UserObj
	showRole?: boolean
	onClick?(): void
	className?: string
}

const AvatarUserInfo = ({
	user,
	showRole,
	onClick,
	className,
}: AvatarUserInfoProps) => {
	return (
		<div
			className={`inline-flex flex-no-wrap items-center my-3 ${
				className ?? ''
			}`}
			key={user.id}
			onClick={onClick}
		>
			<div className="mr-2">
				<Avatar user={user} />
			</div>
			<div className="text-left">
				<UserInfo showRole={showRole} user={user} />
			</div>
		</div>
	)
}

export default AvatarUserInfo
